import { render } from "./CalendarList.vue?vue&type=template&id=1215510d"
import script from "./CalendarList.vue?vue&type=script&lang=js"
export * from "./CalendarList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__